import React, { useCallback } from "react";
import { useHistory, useParams } from "react-router";
import classes from './style.module.scss';
import { useStoreState } from "~/store";
import useTranslation from "~/app/hooks/useTranslation";
import { route } from "~/app/helpers/route";
import { WORKORDER_ROUTES } from "~/workorder/Router";

export type ChecklistComponent = React.FC;

const Checklist: ChecklistComponent = () => {

  const completed = useStoreState(state => state.workOrder.taskData.checklist?.completed ?? 0);
  const total = useStoreState(state => state.workOrder.taskData.checklist?.total ?? 0);
  const { id, taskId, type } = useParams<{ id: string; taskId: string; type: string }>();
  const { t } = useTranslation('service');
  const history = useHistory();

  const handleOpenChecklist = useCallback(() => {
    history.push(route(WORKORDER_ROUTES.taskServiceCheck, { id, taskId, type }));
  }, [history, id, taskId, type]);

  return (
    <div className={classes['card']}>
      <div className={classes['section-header']}>
        <h2 className={classes['section-header-title']}>
          {t('checklist')}
        </h2>
        <button type="button" className={classes['add-action']} aria-hidden tabIndex={-1} onClick={handleOpenChecklist}>
          {`${t('open')} ${t('checklist')}`}
        </button>
      </div>
      <p className={classes['progress-text']}>
        <span className={classes['progress']}>{t('checkpointsCompleted', { completed, total })}</span>
      </p>
    </div>
  );
};

export default Checklist;
